import script from "./blogAuthor.vue?vue&type=script&lang=js"
export * from "./blogAuthor.vue?vue&type=script&lang=js"

import "./blogAuthor.vue?vue&type=style&index=0&id=7619ae5e&lang=scss"

const __exports__ = script;

export default __exports__